import { render, staticRenderFns } from "./GroupStack.vue?vue&type=template&id=377e9d8c&scoped=true"
import script from "./GroupStack.vue?vue&type=script&lang=js"
export * from "./GroupStack.vue?vue&type=script&lang=js"
import style0 from "./GroupStack.vue?vue&type=style&index=0&id=377e9d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e9d8c",
  null
  
)

export default component.exports